import React from 'react';
import {type SxProps, useTheme} from '@mui/material';
import type {SearchMatch, ThesaurusId} from 'services/thesaurus/types';
import {Layout} from 'components';
import {ThesaurusNodePath} from '../../editThesaurus/components';
import {useThesaurusContext} from '../hooks';
import {SearchMatchAction} from './SearchMatchAction';

type Props = {
  thesaurusId: ThesaurusId;
  match: SearchMatch;
};

export const SearchResultMatch: React.FC<Props> = ({thesaurusId, match}) => {
  const {colors} = useTheme();
  const sxNodeButton: SxProps = {
    borderRadius: 1,
    background: colors.lightBeige,
    py: 1,
    pl: 1,
    pr: 2,
  };
  const {searchQuery, getDisplayCode, getNodeAction, addNodeId, removeNodeId} =
    useThesaurusContext(thesaurusId);

  const {ancestors, hasTitleMatch, hasSynonymMatch} = match;

  const showSynonymMatch = hasSynonymMatch && !hasTitleMatch;
  const icon = showSynonymMatch ? 'DoubleChevronRight' : undefined;

  const code = getDisplayCode(match.node);

  return (
    <Layout
      horizontal
      adjustCenter
      justifyContent={'space-between'}
      sx={sxNodeButton}>
      <ThesaurusNodePath
        node={match}
        code={code}
        prefixIcon={icon}
        searchQuery={searchQuery}
        pathSx={sxNodeButton}
        showCategory
      />
      {/* No edit action for category nodes */}
      {ancestors.length > 1 ? (
        <SearchMatchAction
          nodeId={match.node.id}
          action={getNodeAction(match.node.id)}
          addNodeId={addNodeId}
          removeNodeId={removeNodeId}
        />
      ) : null}
    </Layout>
  );
};
